import React from 'react';
import PropTypes from 'prop-types';
import '../Table.css';

const Column = ({
    children
}) => (
    <div className="column">
        {children}
    </div>
);

Column.propTypes = {
    children: PropTypes.node.isRequired,
};

export default Column;
